import Immutable from 'seamless-immutable';
import { CATEGORY_ID, MEMBER_SEARCH_SCREEN } from '../constants/category';
import * as CONSTANTS from '../constants/constants';
import {
  CALL_STATE,
  FACING_MODE,
  FONT_SIZES,
  FRIENDS_DATAKEY,
  PRIMARY_FILTER,
  RECEIVING_CALL_TYPE,
  THEMES,
  TYPE_PAYMENT,
  WINDOW_CALL_TYPE,
  TxtEnum,
} from '../constants/constants';
import { MEMBER_TYPES_REGISTER } from '../constants/memberTypesRegister';
import { FEED_HOME } from '../constants/routes';
import { CALL_STATE_PERMISSION_TYPE, TIMECALLRECEIVE } from '../constants/videoRequestType';
import WebIM from '../libs/webIM';
import categoryModel from '../models/category';
import ChatMessage from 'redhotpie-shared-lib/models/chatMessage';
import { ChatStateEntry } from './chatStateReducer';
import timezone from '../models/timezone';
import ArticleDetails from 'redhotpie-shared-lib/models/articleDetails';
import { ILocationDetail } from 'redhotpie-shared-lib/interfaces/ILocation';

export default {
  foldersReducer: Immutable({
    isAlreadyGetSuccess: false,
    isLoading: false,
    isError: false,
    behavior: '',
    data: {}, // raw of data from backend, don't used
    items: [], // [{ id, name, conversationCount }]
    folderSelected: {},
  }),
  publicLiveStreamsReducer: Immutable({
    filter: {
      pageNumber: 1,
      pageSize: 10,
      // userName: undefined,
      memberType: [],
      minAge: undefined,
      maxAge: undefined,
      // placeId: undefined,
    },
    isAPIDataLoaded: false, // render empty in live streams
    isFiltered: false,
    isHasMore: true,
    pageNumber: 1,
    isLoading: false,
    isError: false,
    behavior: '',
    items: [], // [{ activeSubscribers, totalSubscribers, maxSubscribers, id, roomId, roomJid, userId, ownerXmppId, imageUrl, name, ageTitle, location }]
    data: {},
    selectedLiveStreamRoom: {
      members: [],
      roomJid: '',
      listViewer: [],
      name: '',
      roomId: 0,
      streamId: '',
      avatarUrl: '',
    },
    isShowAlertStoppedPublicLiveStream: false,
    waitingProgress: false,
  }),
  userSearchSettingReducer: Immutable({
    isLoading: false,
    isError: false,
    isAlreadyGetSuccess: false,
    data: {
      maxAge: 0,
      minAge: 0,
      location: {},
      memberType: 0,
      seekingMemberType: 0,
    },
  }),
  memberTypePluralReducer: Immutable({
    isLoading: false,
    isError: false,
    isAlreadyGetSuccess: false,
    items: [],
  }),
  login: {
    isStreaming: false,
    timestampUpdate: 0,
    APIMatchingLoaded: false,
    isLogin: false,
    isLoginOut: false,
    userName: null,
    jIdResource: '',
    rhpUserName: null,
    password: null,
    error: null,
    msg: '',
    fetching: false,
    registerError: null,
    userInfo: {
      userId: 0,
      accountPaused: false,
      isLoadingUserSettings: false,
      isIgnoreConversationEnabled: false,
      messenger: {
        isLoading: false,
        defaultFolder: CONSTANTS.DEFAULT_FOLDER_OPTION.ALL,
        defaultImageDuration: CONSTANTS.MESSAGE_IMAGE_DURATION_ENUM.THREE_MONTHS,
        theme: {
          darkMode: false,
          theme: THEMES.GREEN,
          fontSize: FONT_SIZES.MEDIUM,
          themeType: THEMES.GREEN,
          darkModeSetting: 'Off',
        },
        canReceivePhotos: false,
        canReceiveGifts: false,
      },
      ageTitle: '',
      chatroomSettings: {},
      toolTips: [],
      isInLiveStream: false,
      isVideoCall: false,
      fromUserJid: '',
      isLoadedUserInfo: false,
      profileBoostExpiry: 0,
      lastBoostedConversationTime: {},
    },
    userStatus: {},
    matchingUsers: [],
    userProfile: {},
    isLoginFb: false,
    isResetPassword: false, //
    reconnecting: true,
    connectionStatus: WebIM.statusCode.STATUS_INIT,
    firstCallApis: true,
    phoneNumberCountryCode: {
      name: 'Afghanistan',
      dial_code: '+93',
      code: 'AF',
      latitude: 33,
      longitude: 65,
    },
    isOpenWS: true,
    isLoginXmpp: true,
    gettingUserXmppDetail: false,
  },

  userRegister: Immutable({
    userRegister: {
      location: null,
      fbInfo: null,
      fbLoginInfo: null,
      appleInfo: null,
      googleInfo: null,
    },
    allowcurrentLocation: false,
    location: null,
    currentStep: 1,
    isNextButtonEnabled: true,
    error: null,
    fetching: false,
    registerError: null,
    lookingFor: new categoryModel({ id: CATEGORY_ID.LTM_LOOKING_FOR }),
    ageRange: new categoryModel({ id: CATEGORY_ID.LTM_AGE_RANGE }),
    intentions: new categoryModel({ id: CATEGORY_ID.LTM_INTENTIONS }),
    sex: new categoryModel({ id: CATEGORY_ID.TU1_SEX }),
    age: new categoryModel({ id: CATEGORY_ID.TU1_AGE }),
    ethnicity: new categoryModel({ id: CATEGORY_ID.TU1_ETHNICITY }),
    bodyTypes: new categoryModel({ id: CATEGORY_ID.TU2_BODY_TYPE }),
    height: new categoryModel({ id: CATEGORY_ID.TU2_HEIGHT }),
    orientation: new categoryModel({ id: CATEGORY_ID.TU2_ORIENTATION }),
    general: new categoryModel({ id: CATEGORY_ID.WYI_GENERAL }),
    sexual: new categoryModel({ id: CATEGORY_ID.WYI_SEXUAL }),
    sexualsignle: new categoryModel({ id: CATEGORY_ID.WYI_SEXUAL_SIGNLE }),
    sexualcouple: new categoryModel({ id: CATEGORY_ID.WYI_SEXUAL_COUPLE }),
    fetish: new categoryModel({ id: CATEGORY_ID.WYI_FETISH }),
    aboutYou: new categoryModel({ id: CATEGORY_ID.IY_ABOUT_YOU }),
    yourIdealMatch: new categoryModel({ id: CATEGORY_ID.IY_YOUR_IDEAL_MATCH }),
    personality: new categoryModel({ id: CATEGORY_ID.MPB_PERSONALITY }),
    looks: new categoryModel({ id: CATEGORY_ID.MPB_LOOKS }),
    interests: new categoryModel({ id: CATEGORY_ID.MPB_INTERESTS }),
    mpbLookingFors: new categoryModel({ id: CATEGORY_ID.MPB_LOOKINGFOR }),
    relationship: new categoryModel({ id: CATEGORY_ID.RELATION_SHIP }),
    selectingCategoryId: CATEGORY_ID.LTM_LOOKING_FOR,
    memberType: MEMBER_TYPES_REGISTER.NULL,
    canNextCategory: {
      id: CATEGORY_ID.LTM_LOOKING_FOR,
      indexTab: 0,
    },
    loadingGetCurrentPosition: false,
    currentLocation: null, // lat: ? lng : ?
    // Re-Build Registration
    affiliateLinkID: null,
    seekingTypesMultiSelectArray: [],
    intentionMultiSelectArray: [],
    generalInterestMultiSelectArray: [],
    sexualInterestMultiSelectArray: [],
    fetishInterestMultiSelectArray: [],
    dealBreakerMultiSelectArray: [],
    heightSelectedAsString: '152 cm (5 ft 0 in)',
    heightSelectedAsString2: '152 cm (5 ft 0 in)',
    userProfileDetailInfo: {
      SexualOrientation: null,
      SexualOrientation2: null,
      Race: null,
      Race2: null,
      Height: null,
      Height2: null,
      BodyType: null,
      BodyType2: null,
      SeekingTypes: null,
      Birthdate: null,
      Birthdate2: null,
      SeekingYoungest: 18,
      SeekingOldest: 65,
      FetishInterest: null,
      GeneralInterest: null,
      SexualInterest: null,
      SexualPreference: null,
      Intention: null,
      IntroBody: '',
      MaritalStatus: null,
    },
  }),

  friendsAndFavorites: Immutable({
    isError: false,
    isLoading: false,
    timeRetry: 0,
    data: [],
    displayData: [],
    tempDisplayData: [],
    pageNumber: 0,
    filterIndex: CONSTANTS.FRIENDS_FAVOURITES_FILTER_OPTION.ACTIVE,
    tempFilterIndex: CONSTANTS.FRIENDS_FAVOURITES_FILTER_OPTION.ACTIVE,
    canPaging: true,
    isAPIDataLoaded: false,
  }),

  chatState: Immutable({
    byId: {} as Record<string, ChatStateEntry>,
  }),

  messageSummary: Immutable({
    totalUnread: 0,
  }),

  message: Immutable({
    isError: false,
    isLoading: false,
    action: {
      type: '', // use type in actionType types.CHAT_ADD_SEND_MESSAGE_SUCCESS || types.CHAT_UPDATE_MESSAGE_STATUS || types.CHAT_ADD_RECEIVE_MESSAGE_SUCCESS || types.GET_PHOTO_SUCCESS
      message: {}, // object message xmpp message object in byId
      oldMessage: {}, // object message xmpp message object in byId,
      updatedTime: +new Date(), // time update groupAction object
    },
    groupAction: {
      type: '', // use type in actionType types.CHAT_ADD_SEND_MESSAGE_SUCCESS || types.CHAT_ADD_RECEIVE_MESSAGE_SUCCESS
      message: {}, // object message xmpp message object in byId
      oldMessage: {}, // object message xmpp message object in byId,
      updatedTime: +new Date(), // time update groupAction object
    },
    byId: {} as Record<string, ChatMessage>, // object by messageId
    chat: {} as Record<string, string[]>,
    groupchat: {} as Record<string, string[]>,
    // heartMsg: {},
    lastUpdateMessage: 0,
    messageWaitToSend: {} as Record<string, ChatMessage>, // object by userId: {2590: [{type: 'txt', data: {}}]}
    messagesInvitePrivateGroup: [],
    profilePhotoCommentShouldBeSend: null, // the profile photo message object: {userId, photoId, thumbUrl, fullUrl}
    lastedMessageInviteGroupChatByUser: {} as Record<string, Record<string, ChatMessage>>, // {[fromXmppId: string]: {[groupId]: msgObject}}
    lastedMessageShareEventByUser: {} as Record<string, Record<string, ChatMessage>>, // {[fromXmppId: string]: {[eventId]: msgObject}}
  }),

  group: Immutable({
    byName: {},
    names: [],
  }),

  roster: Immutable({
    byName: null,
    names: [],
    friends: [],
  }),

  common: Immutable({
    fetching: false,
    tabBottomIndex: 1,
    trackingRoute: '',
    tabData: null,
  }),

  subscribe: Immutable({
    byFrom: {},
  }),

  blacklist: Immutable({
    byName: {},
    names: [],
  }),

  courses: [],
  conversations: Immutable({
    showAlertFilter: false,
    chatServerTime: 0,
    isAutoCallMessageAuthor: false,
    removingConversationData: null,
    groupChatShouldBeSelected: '',
    privateRoomJids: [],
    roomJidsBeingJoined: [],
    roomJidsJoinedSuccess: [],
    roomJidsJoinedError: [],
    lastUpdateConversationsDataTime: 0,
    listConversationIdsDeleted: [],
    isSelectingPeerVCard: false,
    shouldSortData: false,
    isAutoOpenMessengerSetting: false,
    conversationsLastSync: 0,
    lastSyncTime: 0,
    isRetry: false,
    isGetOrCreateConversationLoading: false,
    isGetOrCreateConversationError: false,
    statusCodeGetOrCreateConversationError: 200,
    isConversationsError: false,
    isConversationsLoading: false,
    isConversationsLoadingNew: false,
    isConversationsPinedError: false,
    isConversationsPinedLoading: false,
    conversationDetailError: false,
    conversationDetailLoading: false,
    selectedPeerVcard: null,
    data: [],
    dataUnread: {},
    pinListLength: 0,
    pinMatchCount: 0,
    isAPIFullDataLoaded: false,
    isAPIDataPinLoaded: false,
    search: {
      keyword: '',
      primaryIndex: CONSTANTS.PRIMARY_FILTER.ALL,
      secondaryIndex: CONSTANTS.SECONDARY_FILTER.ALL_MESSAGES,
      isSearched: false,
    },
    unreadConversations: 0,
    unreadMatchingConversations: 0,
    isSetReadConversationError: false,
    isSetReadConversationLoading: false,
    selectedConversationInfo: {
      diffTime: 0,
      diffTimeGroup: 0,
      isAPIDataLoaded: false,
      isLoading: false,
      isError: false,
      pinned: false,
      matched: false,
      editorStatus: CONSTANTS.CONVERSATION_STATUS.ERROR_OCCUR, // to resolve RVC-3773
      remainingMessage: 0,
      remainingCredits: 0,
      canVideoCall: true,
      canSend: false,
      canSendPrivate: true,
      canSendPhotos: true,
      id: null,
      memberLevelUserLogin: 0,
      isRecvMatching: false,
      isSenderMatching: false,
      isCreditSend: false,
      timeToReset: 0,
      upgradeAction: 'None',
      conversationKey: '',
      timeUpdateConversationStatus: +new Date(),
      canSendGifts: false,
      msgIdSelected: null,
      isEditMessage: false,
    },
    showDelete: false,
    uploading: [],
    pageNumber: 1,
    showUnreadCount: false,
    userLastMessageTime: null,
    buddyLastMessageTime: null,
    isShowChatModal: false,
    isMemberSearch: false,
    dataPreVCard: {},
    isStatementShown: false,
    isLoggingEnabled: false,
    listMsgDraft: [],
    isAutoSelectFirstConversation: false,
    filters: {
      minAge: 18,
      maxAge: 99,
      location: null,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isVerified: false,
      isHasChangeFilter: false,
    },
    defaultFilters: {
      minAge: 18,
      maxAge: 99,
      location: null,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isVerified: false,
      isHasChangeFilter: false,
    },
    isShowConRefineModal: false,
    location: [],
    filteredLocation: [],
    locationState: [],
    countrySelected: null,
    conversationLocation: null,
    stateSelected: null,
  }),
  users: Immutable({
    isWaitingAvatarLoading: false,
    isWaitingGetMainPhoto: false,
    data: [],
    userIdsCalledAPI: [],
    users: [],
    usersBlockMe: [],
    usersBlocked: [],
    isWhisperChatRooms: false,
    filterActiveModalState: {
      minAge: 0,
      maxAge: 0,
      isMatch: true,
      genders: [],
      location: {},
      disableProximity: true,
      searchRadius: 100,
      seekingType: 0,
    },
    filterActiveStateModalDefault: {
      minAge: 0,
      maxAge: 0,
      isMatch: true,
      genders: [],
      location: {},
      disableProximity: true,
      searchRadius: 0,
    },
    usersActive: [],
    usersActiveByFiltered: [],
    loadingUsersActive: false,
    loadingUsersActiveByFiltered: false,
    hasFilteredUsersActive: false,
    timeGetRequestActiveAPI: 0,
    timeGetRequestFilterActiveAPI: 0,
    sizeParamGetUserActive: 0,
    activeUserPopularState: [],
    activeUserPopularStateSubUrb: [],
    currentStateSelect: null,
    timeInBackground: null,
    userRemainingInvitesCredit: {},
  }),

  iceBreakers: [],

  giftReducer: Immutable({
    giftsReceived: [],
    selectedGiftData: null,
    selectedGiftMessage: null,
    isLoadingGiftData: false,
    giftsData: [],
    categories: [],
    replies: [],
  }),

  privateAlbums: [],
  privateAlbumsAdvance: Immutable({
    isLoading: false,
    byUserId: {},
    numberUsers: 0,
  }),

  quickMessages: [],
  quickMessagesAdvance: Immutable({
    isLoading: true,
    data: [],
    selectedQuickMessage: null,
  }),

  currentScreen: Immutable(CONSTANTS.SCREENS_NAME.DEFAULT_VALUE),
  screenSummary: Immutable({
    orientation: 0,
    preScreen: CONSTANTS.SCREENS_NAME.DEFAULT_VALUE,
    shouldSelectConversationScreen: false,
    directConversation: null,
  }),

  nav: Immutable({
    index: 0,
    screens: [{ name: CONSTANTS.SCREENS_NAME.WELCOME_SCREEN }],
    AppNavigator: null,
    navigationState: {
      index: 0,
      routes: [
        {
          routeName: CONSTANTS.SCREENS_NAME.WELCOME_SCREEN,
        },
      ],
    },
  }),

  appState: Immutable(CONSTANTS.APP_IN_ACTIVE),

  ajaxCallsInProgress: Immutable(0),

  memberProfile: Immutable({
    pageNumber: 1,
    memberViewProfile: undefined,
    positionGoto: 0,
    isFromProfile: false,
    listUsersLiked: [],
    userViewingId: undefined,
    textInput: {
      headerTitle: '',
      isShowTextInput: false,
      onSubmitClick: null,
      onCancleClick: undefined,
      data: '',
      category: '',
      classNames: '',
      minimumLengthTextRequire: 0,
      showImageButton: false,
      showGifButton: false,
      onSelectFile: undefined,
      onClickGifButton: undefined,
    },
    giphyModal: {
      isShowGifModal: false,
      handleHideGifModal: undefined,
      handleSelectGif: undefined,
      extendTopComponent: undefined,
    },
    onFullScreenImage: false,
    isLoading: false,
    isShowViewAllValidations: false,
    isShowAddValidation: false,
    isShowSuccessValidation: false,
    isShowViewAllFriends: false,
    isShowViewAllDateFinder: false,
    isShowSuccessFriend: false,
    isShowProfileOptions: false,
    isSwipeToCloseModalProfile: false,
    isShowOptionReportModal: false,
    isShowAddNote: false,
    idProfileViewNote: -1,
    isShowSuccessNote: false,
    isShowSafeModeConfig: false,
    isShowSafeModeNotify: false,
    hasMoreValidations: true,
    hasMoreFriends: true,
    pageNumberFriend: 1,
    pageNumberValidation: 1,
    isPrivateValidations: false,
    pageSize: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    dateFinderModal: {
      isShow: false,
      userInterests: undefined,
      dateFinder: undefined,
    },
    notificationModal: {
      isShow: false,
      message: '',
      messageKey: '',
    },
    imagesGalleryModal: {
      showModalImage: false,
      imagesData: [],
      selectedIndex: undefined,
      selectedUserId: -1,
    },
    isShowProfileModal: false,
    disableBackCloseModal: false,
  }),

  memberViewProfiles: Immutable({
    index: 0,
    indexActive: 0,
    histories: [],
  }),
  memberSearch: Immutable({
    isLoadingActiveNow: false,
    saveSearches: [],
    usersSortSpotlight: [],
    usersSpotlight: [],
    allowUserActions: true,
    isSearchActiveNow: false,
    idSaveSelect: -1,
    indexSaveSelect: -1,
    stateCarouselView: undefined,
    applySaveSearch: false,
    savedSearches: [],
    isShowOnBoardingProfile: false,
    isSearchInTravel: false,
    error: {
      isError: false,
      message: '',
      timeRetry: 0,
      isShowNoConnection: false,
    },
    fetchingSearch: false,
    fetchingLoadMore: false,
    fetchingFiltersSearch: false,
    isGetUserSearchSetting: false,
    positionGoto: 0,
    userIdProfileViewed: -1,
    autoRunAnimation: null,
    isSearchFilter: false,
    isAutoRunHotKey: false,
    typeAutoRunHotKey: null,
    hasChange: false,
    hasChangeSpotlight: false,
    hasChangePremiumFilters: false,
    isSearchPremiumFilters: false,
    isShowIntro: {
      isLiked: false,
      isIgnore: false,
    },
    searchGuid: null,
    searchGuidSpotlight: null,
    isLoading: false,
    isLoadingAll: false,
    isLoadingMatching: false,
    isLoadingNew: false,
    isLoadingActive: false,
    isLoadingNearby: false,
    isLoadingTravel: false,
    isLoadingSearchUserName: false,
    isLoadingMore: false,
    isLoadingMoreSearchUserName: false,
    isLoadingSpotlightMember: false,
    hasMoreSpotlight: false,
    isShowExpandSearch: false,
    isHasMore: true,
    isHasMoreSearchUserName: true,
    userSearchSettings: {
      userName: '',
      onlineNow: false,
      withPhotos: false,
      isVerified: false,
      hasValidations: false,
      seekingMemberType: 0,
      memberType: 0,
      minAge: 18,
      maxAge: 99,
      searchRadius: 0,
      // location: { latitude: 0, longitude: 0, name: '' },
    },
    memberViewIndex: null,
    memberViewProfile: undefined,
    isSwipingProfile: false,
    memberViewProfiles: {
      index: 0,
      indexActive: 0,
      histories: [],
    },
    memberInteraction: {
      isMatchAccepted: undefined,
      isLikedMutualMatch: false,
      isFavouritedMutualMatch: false,
      params: {
        Type: null,
      },
      user: undefined,
      message: '',
    },
    pageNumber: 1,
    pageNumberSpotlight: 1,
    pageSize: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    users: [],
    usersSearchUserName: [],
    popularNiches: undefined,
    travelDestinations: undefined,
    isShowHotKey: true,
    viewPropertyFilter: null,
    isOutOfLike: null,
    isShowProfileMatch: null,
    isShowInterested: null,
    lastQueryFilters: null,
    showMemberProfileId: null,
    filtersSpotlight: {
      minAge: 18,
      maxAge: 99,
      location: undefined,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      showMeMemberTypeDefault: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isShowLocationFilters: false,
      searchRadius: 100,
    },
    filters: {
      // isShowAddSaveSearch, isShowAllSavedSearches, userName, isFocusUserName
      isShowAddSaveSearch: false,
      isShowAllSavedSearches: false,
      userName: '',
      isFocusUserName: false,
      isCarouselView: false,
      location: undefined,
      isShowPremiumFilters: false,
      isShowLocationFilters: false,
      isSelectLocation: false,
      minAge: 18,
      maxAge: 99,
      searchRadius: 0,
      onlineNow: false,
      withPhotos: false,
      isVerified: false,
      hasValidations: false,
      seekingMemberType: 25,
      niche: '',
      orderByType: [
        {
          id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL,
          key: 'featured',
          title: 'All',
          type: 'All',
          name: 'All',
          isCheck: false,
          value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.MEMBER_LEVEL,
          nameDesktop: 'Featured',
        },
        {
          id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MATCHING,
          key: 'matching',
          title: 'Matching',
          type: 'Matching',
          name: 'Matching',
          isCheck: true,
          value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.MATCHING,
          nameDesktop: 'Matching',
        },
        {
          id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEWEST,
          key: 'newest',
          title: 'New',
          type: 'New',
          name: 'New',
          isCheck: false,
          value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.NEWEST,
          nameDesktop: 'Newest',
        },
        {
          id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE,
          key: 'recentlyActive',
          title: 'Active',
          type: 'Active',
          name: 'Active',
          isCheck: false,
          value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.ACTIVE,
          nameDesktop: 'Recently Active',
        },
        {
          id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.SPOT_LIGHT,
          key: 'spotlight',
          title: 'Spotlight',
          type: 'Spotlight',
          name: 'Spotlight',
          isCheck: false,
          isDesktop: true,
          value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.SPOT_LIGHT,
          nameDesktop: 'Spotlight',
        },
        {
          id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.TRAVELLING,
          type: 'Traveling',
          isCheck: false,
          value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.TRAVELLING,
          isDesktop: true,
          nameDesktop: 'Travelling',
          key: 'traveling',
          title: 'Traveling',
          name: 'Traveling',
        },
        {
          id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEAR_BY,
          key: 'nearBy',
          title: 'Nearby',
          type: 'NearBy',
          name: 'Nearby',
          isCheck: false,
          value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.NEAR_BY,
          nameDesktop: 'Nearby',
        },
        // {
        //     id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE_NOW,
        //     key: 'activeNow',
        //     isCheck: false,
        //     value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.ACTIVE_NOW,
        //     nameDesktop: 'ActiveNow',
        //     isDesktop: true,
        // },
      ],
    },
    isShowInternationalGuestModal: false,
    disableCheckVisa: false,
    showMeMemberType: new categoryModel({
      id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
    }),
    lookingFor: new categoryModel({ id: CATEGORY_ID.MS_LOOKING_FOR }),
    intentions: new categoryModel({ id: CATEGORY_ID.LTM_INTENTIONS }),
    maritalStatus: new categoryModel({ id: CATEGORY_ID.MARITAL_STATUS }),
    bodyTypes: new categoryModel({ id: CATEGORY_ID.TU2_BODY_TYPE }),
    height: new categoryModel({ id: CATEGORY_ID.TU2_HEIGHT }),
    ethnicity: new categoryModel({ id: CATEGORY_ID.TU1_ETHNICITY }),
    sexual: new categoryModel({ id: CATEGORY_ID.WYI_SEXUAL }),
    sexualInterests: new categoryModel({ id: CATEGORY_ID.SEXUAL_INTERESTS }),
    fetish: new categoryModel({ id: CATEGORY_ID.WYI_FETISH }),
    safeSex: new categoryModel({ id: CATEGORY_ID.SAFE_SEX }),
    endowment: new categoryModel({ id: CATEGORY_ID.ENDOWMENT }),
    participationLevel: new categoryModel({
      id: CATEGORY_ID.PARTICIPATION_LEVEL,
    }),
    showMeMemberTypeDefault: new categoryModel({
      id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
    }),
    lookingForDefault: new categoryModel({ id: CATEGORY_ID.MS_LOOKING_FOR }),
    intentionsDefault: new categoryModel({ id: CATEGORY_ID.LTM_INTENTIONS }),
    maritalStatusDefault: new categoryModel({ id: CATEGORY_ID.MARITAL_STATUS }),
    bodyTypesDefault: new categoryModel({ id: CATEGORY_ID.TU2_BODY_TYPE }),
    heightDefault: new categoryModel({ id: CATEGORY_ID.TU2_HEIGHT }),
    ethnicityDefault: new categoryModel({ id: CATEGORY_ID.TU1_ETHNICITY }),
    sexualDefault: new categoryModel({ id: CATEGORY_ID.WYI_SEXUAL }),
    sexualInterestsDefault: new categoryModel({
      id: CATEGORY_ID.SEXUAL_INTERESTS,
    }),
    fetishDefault: new categoryModel({ id: CATEGORY_ID.WYI_FETISH }),
    safeSexDefault: new categoryModel({ id: CATEGORY_ID.SAFE_SEX }),
    endowmentDefault: new categoryModel({ id: CATEGORY_ID.ENDOWMENT }),
    participationLevelDefault: new categoryModel({
      id: CATEGORY_ID.PARTICIPATION_LEVEL,
    }),
    smoking: new categoryModel({ id: CATEGORY_ID.SMOKING }),
    cupSize: new categoryModel({ id: CATEGORY_ID.CUP_SIZE }),
    pubicHair: new categoryModel({ id: CATEGORY_ID.PUBIC_HAIR }),
    smokingDefault: new categoryModel({ id: CATEGORY_ID.SMOKING }),
    cupSizeDefault: new categoryModel({ id: CATEGORY_ID.CUP_SIZE }),
    pubicHairDefault: new categoryModel({ id: CATEGORY_ID.PUBIC_HAIR }),
    isLoadInit: {
      lookingFor: false,
      showMeMemberType: false,
    },
    isSearchMemberModal: false,
    isGetData: false,
  }),
  videoCall: Immutable({
    videoDevices: [],
    switchedView: false,
    callState: CALL_STATE.IDLE,
    callStateStartedBy: CALL_STATE_PERMISSION_TYPE.NONE,
    windowCallType: WINDOW_CALL_TYPE.NONE,
    isMuted: false,
    disableMic: false,
    voiceCallPeerUser: false,
    isStarter: false,
    receivingCallType: RECEIVING_CALL_TYPE.NONE,
    cameraMode: FACING_MODE.USER,
    voiceCall: false,
    callWindow: '',
    callModal: '',
    callFrom: '',
    localSrc: null,
    peerSrc: null,
    peerPhoto: null,
    friendID: '',
    preFriendID: '',
    interruptID: '',
    callInfo: {
      accepted: false,
      watchOnly: false,
    },
    user: {},
    requestType: '',
    showUserPhoto: false,
    showPeerPhoto: false,
    minimize: false,
    data: {},
    timeCountReceive: TIMECALLRECEIVE,
    isFullScreen: false,
  }),
  memberProSpec: Immutable({
    memberViewProfileViewed: undefined,
    memberViewProfileViewMe: undefined,
    memberViewProfileLikedMe: undefined,
    memberViewProfileHaveLiked: undefined,
    memberViewProfileMatch: undefined,
    hasDeletedUsersMatch: false,
    hasDeletedUsersLikedMe: false,
    hasDeletedUsersHaveLiked: false,
    hasDeletedUsersFavedMe: false,
    isUpdateRealtime: false,
    isCarouselView: false,
    memberSummaryProfile: null,
    profileDropDown: {
      userName: undefined,
      isOpenProfileOption: false,
      onBlockUser: undefined,
      onDeleteUser: undefined,
      page: CONSTANTS.PROFILE_OPTION_DROPDOWN_PAGE.PROFILE,
      location: null,
      isHasNotes: false,
      isFavorited: false,
      onAddNotes: undefined,
      onViewNotes: undefined,
      onUnBlockUser: undefined,
      onActionClickReport: undefined,
      onActionClickFavorite: undefined,
      customItem: undefined,
      onCloseOption: undefined,
      moreItems: [],
      positionArrow: '',
    },
    errorUserProfileView: {
      isError: false,
      message: '',
      timeRetry: 0,
      isShowNoConnection: false,
    },
    errorUserFav: {
      isError: false,
      message: '',
      timeRetry: 0,
      isShowNoConnection: false,
    },
    errorUserLikes: {
      isError: false,
      message: '',
      timeRetry: 0,
      isShowNoConnection: false,
    },
    errorUserMatch: {
      isError: false,
      message: '',
      timeRetry: 0,
      isShowNoConnection: false,
    },
    isLoadedFirstTime: false,
    dataKey: null,

    // User ProfileView
    isGetUserSearchSetting: false,
    isGetMemberType: false,
    isFetchingUserProfileViewTypeViewMe: null,
    isFetchingUserProfileViewTypeViewed: null,
    userProfileViewTypeViewMe: [],
    userProfileViewTypeViewed: [],
    loadMoreUserProfileViewTypeViewMe: false,
    isLoadMoreUserProfileViewTypeViewMe: false,
    isHasMoreItemUserProfileViewTypeViewMe: true,
    loadMoreUserProfileViewTypeViewed: false,
    isLoadMoreUserProfileViewTypeViewed: false,
    isHasMoreItemUserProfileViewTypeViewed: true,
    pageNumberProfileViewMe: 0,
    pageNumberProfileViewed: 0,
    filtersUserView: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    defaultFilterViews: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    stateCountProfileViewTypesViewMe: [],
    stateCountSubProfileViewTypesViewMe: [],
    stateCountProfileViewTypeViewed: [],
    stateCountSubProfileViewTypeViewed: [],

    // User Favourites
    isFetchingUserUserLikeTypeLikeMe: null,
    isFetchingUserUserLikeTypeHaveLiked: null,
    userUserLikesTypeLikedMe: [],
    userUserLikesTypeHaveLiked: [],
    loadMoreUserLikesTypeLikeMe: false,
    isLoadMoreUserLikesTypeLikeMe: false,
    isHasMoreUserLikesTypeLikeMe: true,
    loadMoreUSerLikesTypesHaveLiked: false,
    isLoadMoreUSerLikesTypesHaveLiked: false,
    isHasMoreUserLikesTypesHaveLiked: true,
    pageNumberUserLikedMe: 0,
    pageNumberUserHaveLiked: 0,
    filterUserLikes: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isFavourite: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    defaultFilterLikes: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isFavourite: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    isHasChangeFilterLikes: false,
    isDoFilterLikes: false,
    stateCountFavouritesTypeLikeMe: [],
    stateCountSubFavTypeLikeMe: [],
    stateCountFavouritesTypeHaveLiked: [],
    stateCountSubFavTypeHaveLiked: [],

    // User Likes
    isFetchingLikeTypeLikeMe: null,
    isFetchingLikeTypeHaveLiked: null,
    likesTypeLikedMe: [],
    likesTypeHaveLiked: [],
    loadMoreLikesTypeLikeMe: false,
    isLoadMoreLikesTypeLikeMe: false,
    isHasMoreLikesTypeLikeMe: true,
    loadMoreLikesTypesHaveLiked: false,
    isLoadMoreLikesTypesHaveLiked: false,
    isHasMoreLikesTypesHaveLiked: true,
    pageNumberLikedMe: 0,
    pageNumberHaveLiked: 0,
    filterLikes: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isFavourite: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    dFilterLikes: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isFavourite: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    isChangedFilterLikes: false,
    isSearchFilterLikes: false,
    stateCountLikesTypeLikedMe: [],
    stateCountSubLikesTypeLikedMe: [],
    stateCountLikesTypeHaveLiked: [],
    stateCountSubLikesTypeHaveLiked: [],

    // User UserMatches
    isFetchingUserUserMatch: null,
    userUserMatch: [],
    loadMoreUserMatch: false,
    isLoadMoreUserMatch: false,
    isHasMoreUserMatch: true,
    pageNumberUserMatch: 0,
    filtersUserMatch: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isFavourite: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    defaultFilterMatch: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      matchingMember: false,
      isFavourite: false,
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    isLoadingCount: false,
    count: {
      profileView: 0,
      favourites: 0,
      matches: 0,
    },
    positionGoto: 0,
    stateCountMatch: [],
    stateCountSubMatch: [],
    loadInitDataTime: 0,
    // userUserLikesTypesHaveLiked: [],
  }),
  commonState: Immutable({
    isShowNotificationUserInterestModal: false,
    idPaySelect: -1,
    indexTypeUpgrade: 0,
    typeRender: '',
    callbackPaySuccess: undefined,
    browserModalCustomContainer: undefined,
    widthMax: 0,
    heightMax: 0,
    isHideLoadingBrowserModal: false,
    isShowRestrictedPublicPhotosTooltip: false,
    isShowNotificationGroupJoins: false,
    isShowRequestToJoin: false,
    requestData: {
      groupDetail: undefined,
      groupOwner: undefined,
    },
    isShowNotificationInvitationModal: false,
    invitationType: CONSTANTS.NOTIFICATIONS.TYPE_OF_GROUP_NOTIFICATION.CLUB_INVITATION,
    isShowMyGroupsModal: false,
    isShowJoinedGroupsModal: false,
    metadataGroupMemberModal: undefined,
    metadataGlobalPreviewMediaModal: undefined,
    isShowSuggestedMember: false,
    inviteUserParentType: 'Group',
    isSuggestedMemberClubEvent: false,
    idSuggestedFor: 0,
    inviteUserAction: undefined,
    isShowReviewsModal: false,
    isShowNotificationGroupJoinRequestModal: false,
    isShowNotificationGroupActivityModal: false,
    createNewPassWordModal: {
      isShowModal: false,
      callbackCreatePasswordSuccess: undefined,
      callbackCreatePasswordFailed: undefined,
      description: '',
    },
    verifyPasswordModal: {
      isShowModal: false,
      callbackVerifyPasswordSuccess: undefined,
      description: '',
    },
    photoCommonModalInfo: {
      titleModal: '',
      isShowModal: false,
      photos: null,
      totalItems: 0,
      getComment: undefined,
      getLike: undefined,
      idxImageSelected: 0,
      setIndexImageSelected: undefined,
      handleUpdateCountComment: undefined,
      callbackDeleteComment: undefined,
      handleClickLikePhoto: undefined,
      imgContentItem: undefined,
      getMoreReplies: undefined,
    },
    isShowStreamFilterTooltip: false,
    tooltipModal: {
      isShowModal: false,
      content: null,
      style: { top: '50%', left: '50%' },
    },
    createEventAs: {
      isShowModal: false,
      callback: undefined,
    },
    likeModalInfo: {
      isShowModal: false,
      funcGetLike: undefined,
      contentItem: null,
      funcLikeUnlikeItem: undefined,
      callbackCloseModal: undefined,
    },
    commentModalInfo: {
      isShowModal: false,
      isOwner: false,
      contentItem: null,
      funcGetComment: undefined,
      funcGetReply: undefined,
      funcClickLike: undefined,
      funcCreateComment: undefined,
      funcCallbackDeleteComment: undefined,
      callbackCloseModal: undefined,
      verifyBeforeDeleteComment: undefined,
    },
    isShowCreateEditGroup: false,
    locationSearchInfo: {
      isShowLocationSearchModal: false,
      onCancelClick: undefined,
      onActionClick: undefined,
      isEvent: false,
      isClubOrganiser: false,
      isSuburbOnly: false,
      clubState: undefined,
      clubStateSubUrb: undefined,
      location: undefined,
      searchType: '',
    },
    isShowReportV2Modal: false,
    reportV2Data: undefined,
    isShowNotificationPhotoLikeModal: false,
    disableShowTooltip: false,
    // Params for Gallery modal
    isShowGalleryModal: false,
    otgContentItem: null,
    initPhotoItem: null,
    photoId: -1,
    photoIndex: -1,
    //
    isAppError: false,
    isShowWhatNewModal: false,
    isShowWhatNewModalV2: false,
    isShowExtendBoostModal: false,
    extendBoostModalInfo: {
      views: 0,
      likes: 0,
      messages: 0,
      viewsPercent: 0,
      likesPercent: 0,
      messagesPercent: 0,
    },
    isShowOnboardingSpotlightModal: false,
    dataSpotlightModal: [],
    ageModalInfo: {
      isShow: false,
      ageInfo: null,
      onClickDone: null,
      idTabSelected: 1,
    },
    isShowSpotlightInfo: false,
    autoOpenContactSupport: null,
    // Data for Get Boost modal
    isShowGetBoostModal: false,
    // Data for Boost modal
    isShowBoostModal: false,
    boostsType: CONSTANTS.BOOSTS_TYPE.PROFILE,
    isInfo: false,
    // Data for My Conversations Credits
    isShowMyConversationsBoostsModal: false,
    myType: CONSTANTS.MY_TYPE.CONVERSATION,
    // Param of Event interest
    usernameFilterInInterest: '',

    // Data for Payment Transaction modal
    isShowTransactionModal: false,
    paymentRes: undefined,
    bodyParams: undefined,
    // END
    isShowStatus: false,
    statusInfo: CONSTANTS.APPROVAL_STATUS.PENDING,
    screenStatus: null,
    // isShowDateFinderDetail: false,
    // dateFinderSelected: null,
    // dateFinderSettingModal: null,
    interestedInEventPosition: 0,
    windowDimensions: undefined,
    seoURL: undefined,
    titleHeader: '',
    isShownMessengerUnavailable: false,
    isShownChatroomUnavailable: false,
    isShowShareUrlModal: false,
    isShowIntroducingMessengerGiftModal: false,
    isShowIntroducingMessengerBoostModal: false,
    isShowDiamonds: false,
    isShowPurchasesCoins: false,
    isShowRHPCoins: false,
    needMoreCoins: 0,
    callbackAfterGetMoreCoinsSuccess: null,
    isShowContactUs: false,
    autoCloseRulesModal: false,
    tempRoomJid: '',
    showMessengerSettings: false,
    showReactionModal: false,
    reactions: [],
    reactionHeader: '',
    isUsingPreviewPhotoToSendImage: false,
    selectPhotoPreview: null,
    previewDataSet: undefined,
    actionNotification: {
      type: '',
      userId: -1,
      itemId: -1,
    },
    isConversationCredit: false,
    isGetCoins: false,
    isGetMoreCoins: false,
    isShowContactSupportUnAuthorizeModal: false,
    // isContactSupportAccessIssueLogin: false,
    isShowActiveNowModal: false,
    activeNowModalTabSelected: CONSTANTS.ACTIVE_NOW_KEYS.FRIENDS,
    activeModalData: {
      friends: {
        data: [],
        isHasMoreData: true,
        loading: false,
        page: 1,
      },
      favorites: {
        data: [],
        isHasMoreData: true,
        loading: false,
        page: 1,
      },
    },
    gettingAboutRhpData: true,
    aboutRhpData: [],
    isShowAuthenticationModal: false,
    isScammerMode: false,
    isUserRejectAuthModal: false,
    isShowRatingModal: false,
    // Upgrade info
    isShowModalUpgradeInfo: false,
    isShowModalGetConversations: false,
    isUpgradeInfo: false,
    // Travel plan detail
    isShowTravelPlanDetail: false,
    travelPlanItem: undefined,
    // MessageError
    messageNotificationError: '',
    confirmModal: {
      messageConfirm: '',
      onOkAction: undefined,
      okText: '',
      cancelText: '',
      headerText: '',
      wrapperPosition: 0,
      onCancelAction: undefined,
      messageConfirmExternal: '',
      messageConfirmExternal2: '',
      extraFooter: undefined,
      customZIndex: 0,
      customClassButton: '',
      customClassOk: '',
      customClassCancle: '',
      classNames: '',
      disableCancel: false,
      disableClickOverlay: false,
      noClearCancelAction: false,
      keepModalWhenClickCancel: false,
      isMoreEndGroupChat: false,
      disableEscClose: false,
      disableBackBrowserCloseModal: false,
      isBottomModal: false,
      isOptionModal: false,
      isOverlayBlack: false,
      callbackRunAnimation: undefined,
    },
    isShowProfilePopup: false,
    isFromToOpenProfile: '',
    isShowBrowserModal: false,
    urlBrowserModal: '',
    isShowSettingModal: false,
    inAppNotificationData: {},
    isShowInAppNotification: false,
    isSupportNotificationManager: false,
    inAppNotificationsManagerData: [],
    currentLocation: {
      coordinates: undefined,
      error: '',
      preCoordinates: undefined,
      detail: undefined,
      type: undefined,
      loadSuccess: false,
    },
    currentLocationSuburb: {
      GoogleMapPlacesId: '',
    },
    menuIsSeleted: FEED_HOME,
    subMenuIsSeleted: '',
    isShowModalPickLocation: false,
    isDesktop: false,
    isShowModalUpgradeMember: false,
    idSlideUpgrade: 0,
    idTypeUpgrade: CONSTANTS.MEMBER_TYPES.PREMIUM_PLUS,
    isShowBenefit: false,
    isNoConnection: false,
    isShowModalPaymentOptions: false,
    isErrorAPI: false,
    isShowModalSubscription: false,
    isShowCompare: false,
    prevPath: '',
    isShowModalVerify: false,
    isShowSensitive: false,
    sensitiveContent: {
      content: undefined,
      okText: '',
      cancelText: '',
      cancelAction: undefined,
    },
    isFeedback: false,
    timeInBackground: null,
    isProfileModalConversationOpen: false,
    currentViewingProfileId: null,
    isOpenModalAuthenticate: false,
    isShowVerifyMessengerAccount: false,
    //    isShowVerifyMessengerAccount: true,
    isShowWalletModal: false,
    isShowRecentlySentPhotos: false,
    isShowSetMessageImageDurationModal: false,
    canSetDefaultValueImageDurationModal: false,
    imageDurationSelectionValue: TxtEnum.ThreeMonths,
    userSharedPhotos: {
      data: [],
      page: 1,
      size: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      isHasMore: true,
      paginationInfo: { totalItems: 0 },
    },
    isShowDisappearingPhotos: false,
    isShowThePiePledgeModal: false,
    isShowAppearingPhotosLearnMore: false,
    isShowSecureAccount: false,
    isShowConnectApple: false,
    callbackConnectApple: undefined,
    hadShowNotification: false,
    isShowModalOrders: false,
    isShowTriedRememberingPassword: false,
    isShowRules: false,
    participantInfo: {
      isShowParticipants: false,
      isView: false,
      eventId: -1,
      title: '',
      partiCount: 0,
    },
    isShowConversationCredits: false,
    metricsStatus: 0,
    chatSystemDownModalShow: false,
    unavailablePopupShown: {
      messenger: false,
      chatroomSettings: false,
    },
    isShowOnboardingMessenger: false,
    disableReconnectingLabel: false,
  }),
  groupChat: Immutable({
    optionProfileSummaryModal: null,
    toggleCloseLiveStream: false,
    isLoadingMemberData: false,
    membersJoining: {},
    freeChatBanner: null,
    closingTime: null,
    displayFreeChat: false,
    flagLoadMessage: false,
    isAPIDataLoaded: false,
    isLoadingGroups: false,
    isLoadGroupsFailed: false,
    authorized: {},
    data: [],
    selectedGroup: {
      roomJid: null,
      roomName: null,
      coverUrl: null,
      roomDisplayName: null,
      occupants: null,
      loaded: null,
      members: [],
      owner: null,
      roomId: 0,
      id: 0,
    },
    nextSelectedGroup: {
      roomJid: null,
      roomName: null,
      coverUrl: null,
      roomDisplayName: null,
      occupants: null,
      loaded: null,
      members: [],
      roomId: 0,
      id: 0,
    },
    isUserBanned: false,
    waitingProgress: false,
    profileNoteMember: {},
    isSortLiveStream: false,
    isAlReadyLogged: false,
    groupCanBeInvite: {
      loading: false,
      data: [],
    },
    groupShouldSendJoinGroupChatMessage: [],
    roomJidShouldSendJoinGroupChatMessage: [],
    roomJidSendingJoinGroupChatMessage: [],
    groupChatMessageStatus: {
      sendMessageBan: false,
      sendMessageBanExpiry: null,
      sendPhotoBan: false,
      sendPhotoBanExpiry: null,
    },
    featureRooms: [],
    isLoadedFeatureRooms: false,
  }),
  newFeedState: Immutable({
    idTimeout: null,
    isLoadingPopularGroups: false,
    dataPopularGroups: [],
    isCallAPINewFeedIgnoreTimeout: false,
    isShowOnBoardingNotification: false,
    isShowOnBoarding: false,
    dataNewFeed: [],
    dataPinnedContent: [],
    dataDateFinder: [],
    isLoadingNewFeed: false,
    isHasMoreNewFeed: true,
    pageNumber: 1,
    activitySumaryUsers: {
      newUsers: [],
      activeUsers: [],
    },
    isLoadingActivitySumaryUsers: false,
    isLoadingRecent: false,
    recentUsers: [],
    isLoadMore: false,
    timeToReset: null,
    error: {
      isError: false,
      message: '',
      timeRetry: 0,
      isShowNoConnection: false,
    },
    dateFinder: {
      myDates: 0,
      totalDates: 0,
      matchDates: 0,
    },
    activeUsers: {
      total: 0,
      favorites: 0,
      friends: 0,
    },
    prospectsSummary: {
      recentViews: 0,
      thisMonthViews: 0,
      favoritedMe: 0,
      haveFavourited: 0,
      matches: 0,
      likedMe: 0,
      iLiked: 0,
    },
    dataCompetitions: [],
    announcementBanner: {
      bannerImageUrl: '',
      announcementType: '',
      destinationURL: '',
      announcementItemID: 0,
    },
    announcementBannerDesktop: {
      bannerImageUrl: '',
      announcementType: '',
      destinationURL: '',
      announcementItemID: 0,
    },
    testimonialsItem: {
      isShowModal: false,
      data: null,
    },
    scrollOld: 0,
    filterValidated: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      showMeMemberTypeDefault: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
    },
  }),
  liveStream: Immutable({
    hiddenStatusBar: false,
    loginUserStream: {
      streamId: null,
      streamName: '',
      listViewer: [],
    },
    selectedStream: {
      streamId: null,
      streamName: '',
      listViewer: [],
    },
    viewerByStreamId: {},
    listLiveStreamsInRoom: [],
    listCurrentLiveStream: [],
    memberLiveStreams: [],
    toggleCheckLiveStream: '',
  }),
  notificationState: Immutable({
    // Alert
    dataAlert: [],
    isLoadingAlert: false,
    isHasMoreAlert: true,
    pageNumberAlert: 1,
    // Event Interest
    dataUserEventInterest: [],
    isLoadingEventInterest: false,
    isHasMoreEventInterest: true,
    pageNumberEventInterest: 1,
    totalEventInterest: 0,
    // Comment
    // Notification
    dataNotification: [],
    isLoadingNotification: false,
    isHasMoreNotification: true,
    pageNumberNotification: 1,
    //PhotoLikes
    dataPhotoLikes: [],
    isLoadingPhotoLikes: false,
    pageNumberPhotoLikes: 1,
    totalPhotoLikes: 1,
    isHasMorePhotoLikes: false,
    // Validation
    dataValidation: [],
    totalValidation: 0,
    isLoadingValidation: false,
    isHasMoreValidation: true,
    pageNumberValidation: 1,
    // Friend Request
    dataFriendRequest: [],
    totalFriendRequest: 0,
    isLoadingFriendRequest: false,
    isHasMoreFriendRequest: true,
    pageNumberFriendRequest: 1,
    isCalledFriendRequest: false,
    // Friend
    dataFriend: [],
    totalFriend: 0,
    isLoadingFriend: false,
    isHasMoreFriend: true,
    pageNumberFriend: 1,
    isCalledFriend: false,
    // DateFinder
    dataDateFinder: [],
    isLoadingDateFinder: false,
    isHasMoreDateFinder: true,
    pageNumberDateFinder: 1,
    // DateFinder Interest
    dataDateFinderInterest: [],
    isLoadingDateFinderInterest: false,
    isHasMoreDateFinderInterest: true,
    pageNumberDateFinderInterest: 1,
    tabSelected: FRIENDS_DATAKEY.FRIENDS_REQUEST,
    //Group invitation
    dataGroupInvitation: [],
    isLoadingGroupInvitation: false,
    isHasMoreGroupInvitation: false,
    pageNumberGroupInvitation: 1,
    totalGroupInvitation: 0,
    //Event invitation
    dataEventInvitation: [],
    isLoadingEventInvitation: false,
    isHasMoreEventInvitation: false,
    pageNumberEventInvitation: 1,
    totalEventInvitation: 0,
  }),
  eventState: Immutable({
    isLoadMore: false,
    isShowClubDetail: false,
    idClubDetail: -1,
    // desktop
    isShowCreateEditEventModal: false,
    isShowInterestedInEventDesktopModal: false,
    isShowInterestedInUserEventDesktopModal: false,
    isShowMyEventsModal: false,
    idEventSelected: -1,
    isGetUserSearchSetting: false,
    //
    filtersEventSearch: {
      categoryId: -1,
      dateStart: null,
      dateEnd: null,
      location: {},
      searchRadius: 0,
    },
    defaultFiltersEventSearch: {
      categoryId: -1,
      dateStart: null,
      dateEnd: null,
      location: {},
      searchRadius: 0,
      // sponsoredType: "All", // SponsoredType  Accepted values are All, NonSponsored, Sponsored// Only use for list event do not use for event near
    },
    isChangeFilter: false,
    isSearchFilter: false,
    listTimezone: [],
    filtersClubSearch: {
      categoryId: -1,
      location: {},
    },
    // isChangeClubFilter: false,
    // Event Interested in
    dataInterested: [],
    isLoadingInterested: false,
    totalEventInterested: 0,
    indexPopularSelected: 0,
    paramsForInterested: null,
    // filter
    filtersTypeCreateEvent: {
      minAge: 25,
      maxAge: 65,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      showMeMemberTypeDefault: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
    },
    filterInterested: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      membersWhoAre: PRIMARY_FILTER.ALL,
      initMemberType: false,
      isChangeFilter: false,
      isHasMore: false,
      page: 1,
      isLoadingFilter: false,
      autoCallAPIFilter: false,
    },
    defaultFilterInterested: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      membersWhoAre: PRIMARY_FILTER.ALL,
      initMemberType: false,
      isChangeFilter: false,
      isHasMore: false,
      page: 1,
      isLoadingFilter: false,
      autoCallAPIFilter: false,
    },
    // EventDetail
    isLoadingEventDetail: false,
    dataDetailEvent: {
      detail: {
        ageMin: null,
        ageMax: null,
        description: '',
        theme: '',
        dressCode: '',
        rules: '',
        cost: '',
        ticketUrl: '',
        phone: '',
        email: '',
        website: '',
        guestTypes: [],
        eventId: 0,
        title: '',
        dateHeld: '',
        categories: [],
        organiserType: '',
        eventBannerUrl: '',
        eventFeaturedBannerUrl: '',
        eventGlobalBannerUrl: '',
        location: {},
        timezone: null,
        dateHeldUtcIso: null,
        dateHeldUtcIsoEx: null,
        videoUrl: '',
        videoType: '',
        videoThumbUrl: '',
      },
      isSponsored: false,
      isFeatured: false,
      organiser: {
        __type: '',
        displayEmail: '',
        website: '',
        description: '',
        clubId: 0,
        clubName: '',
        location: undefined,
        categories: [],
        rating: 0,
        mainPhoto: undefined,
        userId: 0,
        isViewable: true,
      },
      hasExpressInterest: false,
      organiserType: 'Member',
      isGroupChatAvailable: false,
      totalComment: 0,
      isViewerOwner: false,
      isTicketUrlPrivate: false,
      seoURL: '',
      isUserMatching: false,
    },
    // UserEvents
    isLoadingUserEvents: false,
    pageNumberUserEvents: 1,
    isHasMoreUserEvents: false,
    dataUserEvents: [],
    // EventDetail Of User
    isLoadingEventOfUser: false,
    dataDetailEventOfUser: {},
    totalComments: 0,
    eventError: false,

    // shareMyEvents in messenger data
    isLoadingShareMyEvents: false,
    isHasMoreShareMyEvents: false,
    shareMyEvents: [],
    pageNumberShareMyEvents: 1,
    isLoadMoreShareMyEvents: false,

    // EventUserInterest
    isLoadingUserEventInterest: false,
    pageNumberUserEventInterest: 1,
    isHasMoreUserEventInterest: false,
    dataUserEventInterest: [],

    // EventInterest
    dataEventInterest: [],
    isLoadingEventInterest: false,
    pageNumberEventInterest: 1,
    totalEventInterest: 0,
    isHasMoreEventInterest: false,
    isShowInterestedInEventModal: false,
    fromScreen: '',
    eventInterestId: null,
    hasExpressInterest: false,
    eventDateHeld: null,
    eventIndex: -1,
    eventGroupIndex: -1,
    eventGroupTitle: '',
    filterHasChange: false,

    // EventComment
    isLoadingEventComment: false,
    dataEventComment: [],
    dataEventCommentTmp: [],
    isHasMoreEventComment: true,
    // Event Reply
    isLoadingEventReply: false,
    isLoadMoreReply: false,
    isHasMoreReply: true,
    currentLoadMoreReply: {
      commentParentID: null,
      page: 1,
    },
    // EventSearch
    dataEventSearch: [],
    dataEventSearchSponsor: [],
    isCalledEventSearchAPI: false,
    isCalledEventSearchSponsoredAPI: false,
    isLoadingEventSearch: false,
    isLoadingEventNonSponsored: false,
    isLoadingEventSearchSponsored: false,
    pageNumberEventSearch: 1,
    pageNumberEventSearchSponsored: 1,
    totalEventSearch: 0,
    totalEventSearchSponsored: 0,
    isHasMoreEventSearch: false,
    isHasMoreEventSearchSponsored: false,
    // EventCreate
    isLoadingCreateEvent: false,
    eventCategory: [],
    clubCategory: [],
    // location seacrch
    eventPopularState: [],
    currentStateSelect: null,
    eventPopularStateSubUrb: [],
    currentLocation: {},
    positionGoto: 0,
    isSearchInTravel: false,
    isCalledSponsoredAPI: false,
    isCalledNoSponsoredAPI: false,
    clubState: [],
    pageClubSearch: 1,
    clubStateSubUrb: [],

    // Club Search
    dataClubSearch: [],
    isLoadingClubEvents: false,
    isHasMoreClubEvents: false,
    isLoadedDataClubEvents: false,
    isLoadingDetailClubEvents: false,
    dataDetailClub: {},
    dataPhotoDetailClub: [],
    // Club detail
    clubId: -1,

    isLoadingVoteComments: false,
    pageNumberVoteComments: 1,
    isHasMoreVoteComments: false,
    totalVoteComments: 0,
    voteComments: [],
    isLoadingClubEvt: false,
    pageNumberClubEvt: 1,
    isHasMoreClubEvt: false,
    totalClubEvt: 0,
    clubEvt: [],
    clubPastEvt: [],
    isHasMoreClubPastEvt: false,
    isLoadingClubPastEvt: false,
    pageNumberClubPastEvt: 1,
    totalClubPastEvt: 0,

    // Suggested Users
    suggestedUsers: {
      data: [],
      isLoading: false,
      isLoadingMore: false,
      isHasMore: true,
      pageNumber: 1,
      total: 0,
      searchGuid: '',
    },
    suggestedUsersFilter: {
      memberTypes: [],
      defaultMemberTypes: [],
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 100,
      isHasChangeFilter: false,
      isApplyFilter: false,
    },

    defaultSuggestedMemberFilters: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      ageMax: 99,
      ageMin: 18,
      location: {},
      searchRadius: 100,
      isHasChangeFilter: false,
    },
    suggestedMemberFilters: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      ageMax: 99,
      ageMin: 18,
      location: {},
      searchRadius: 100,
      isHasChangeFilter: false,
    },
  }),
  notificationSummaryState: Immutable({
    newFeed: {
      totalNotificationCount: 0,
      showSupportTicket: false,
    },
    prospects: {
      newFavourites: 0,
      newMatches: 0,
      newViews: 0,
      newLikes: 0,
      totalLikes: 0,
      totalMatches: 0,
    },
  }),
  editProfileState: Immutable({
    gender: [],
    memberTypeLabel: '',
    dealBreaker: [],
    profilePhotos: [],
    photoData: [],
    galleries: [],
    isLoadedGaleries: false,
    isFetchingGallery: false,
    isFetchingUserPhotos: false,
    hasPhotoRejected: false,
    photoRejected: [],
    photoRestricted: [],
    hasPhotoRestricted: false,
    userPhoto: [
      {
        id: CONSTANTS.EDIT_PROFILE.PUBLIC_ID,
        data: [],
      },
      {
        id: CONSTANTS.EDIT_PROFILE.MAIN_PHOTO_ID,
        data: [],
      },
    ],
    isLoadedUserPhotos: false,
    // general info data
    isLoadedFullGeneralDetail: false,
    maritalStatus: [],
    sexualOrientation: [],
    race: [],
    personality: [],
    myLooks: [],
    bodyType: [],
    height: [],
    eyeColour: [],
    hairColour: [],
    hairLength: [],
    drinking: [],
    smoking: [],

    // intimate info data
    safeSex: [],
    bodyHair: [],
    pubicHair: [],
    endowmentLength: [],
    endowmentThickness: [],
    intimatePiercing: [],
    sexualPersonality: [],
    cupSize: [],
    //
    sexualInterestSingle: [],
    sexualInterestCouple: [],
    generalInterest: [],
    fetishInterest: [],
    // profileBuilder
    profileBuilderPersonality: [],
    profileBuilderLooks: [],
    profileBuilderInterest: [],
    profileBuilderSeeking: [],
    // participation
    participation: [],
    // intention
    intention: [],
    seekingRelationshipStatus: [],
    memberType: new categoryModel({ id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE }),
    // general Info
    maritalStatusLabel: null,
    maritalStatusLabel2: null,
    sexualOrientationLabel: null,
    sexualOrientationLabel2: null,
    raceLabel: null,
    raceLabel2: null,
    personalityLabel: null,
    personalityLabel2: null,
    myLooksLabel: null,
    myLooksLabel2: null,
    bodyTypeLabel: null,
    bodyTypeLabel2: null,
    heightLabel: null,
    heightLabel2: null,
    eyeColourLabel: null,
    eyeColourLabel2: null,
    hairColourLabel: null,
    hairColourLabel2: null,
    hairLengthLabel: null,
    hairLengthLabel2: null,
    drinkingLabel: null,
    drinkingLabel2: null,
    smokingLabel: null,
    smokingLabel2: null,
    // Intimate Info
    safeSexLabel: null,
    safeSexLabel2: null,
    bodyHairLabel: null,
    bodyHairLabel2: null,
    pubicHairLabel: null,
    pubicHairLabel2: null,
    endowmentLengthLabel: null,
    endowmentLengthLabel2: null,
    endowmentThicknessLabel: null,
    endowmentThicknessLabel2: null,
    intimatePiercingLabel: null,
    intimatePiercingLabel2: null,
    sexualPersonalityLabel: null,
    sexualPersonalityLabel2: null,
    cupSizeLabel: null,
    cupSizeLabel2: null,
    // participation
    participationLabel: null,
    participationLabel2: null,
    //
    intentionLabel: null,
  }),
  validations: Immutable({
    tabAutoSelected: null,
    myValidation: [],
    validationSent: [],
    pageMyValidations: 1,
    pageValidationSent: 1,
    isLoadingMyValidation: false,
    isLoadingValidationSent: false,
    isHasMoreMyValidations: true,
    isHasMoreValidationSent: true,
    isCalledMyValidation: false,
    isCalledValidationSent: false,
  }),
  blockList: Immutable({
    data: [],
    page: 1,
    isLoading: false,
    isHasMore: true,
    isCalled: false,
    isCallingLoadMore: false,
  }),
  hiddenList: Immutable({
    data: [],
    page: 1,
    isLoading: false,
    isHasMore: true,
    isCalled: false,
    isCallingLoadMore: false,
  }),
  paymentGateway: Immutable({
    additionalPaymentOptions: undefined,
    currency: undefined,
    isPaymentAvailable: false,
    paymentOptions: [],
    products: [],
    nonSubscriptionProducts: [],
    userDiscount: CONSTANTS.PAYMENT_GATEWAY.DISCOUNT.NO_DISCOUNT,
    costSelected: null,
    typeProductSelected: -1,
    diamonds: 0,
    isExistsCreditCard: false,
    productOptions: [],
    purchaseToken: '',
    diamondsBalance: 0,
    coinCredits: [],
    storeCredits: [],
    currentStoreCredits: 0,
    currentConversationCredits: 0,
    conversationCredits: [],
    upgradePath: '',
    verotePaymentOptions: undefined,
    highestCoinUnitPrice: 1,
    updateToken: '',
    productToken: '',
  }),
  dateFinderState: Immutable({
    dateFinderEdit: null,
    isShowGreatIdealModal: false,
    disableDefaultSelectDate: false,
    findGreatIdealModal: false,
    isShowAllMyDates: false,
    showAddDateModal: false,
    isShowSingleSelectDate: false,
    quickDateSelect: '',
    isLoadedSearchData: false,
    isLoadedMyDate: false,
    dataListMyDate: [],
    isLoadingListMyDate: false,
    isHasMoreListMyDate: true,
    pageNumListMyDate: 1,
    dataDetailDate: {},
    isLoadingDetailDate: false,
    dataDateInterests: [],
    isLoadingDateInterest: false,
    isHasMoreDateInterest: true,
    pageNumDateInterest: 1,
    //
    dates: [],
    pageNumberDates: 1,
    pageSizeNumberDates: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_DATE_FINDER,
    isHasMoreDates: true,
    datesSuggested: [],
    isHasMoreDateSuggested: true,
    isFetchingDates: false,
    isGetMemberType: false,
    quickDateFilter: '',
    quickFilterLocationDateFilter: {},
    descriptions: [],
    meetingTypes: [],
    filter: {
      isCanHost: false,
      ageMin: 18,
      ageMax: 99,
      location: {
        StateName: '',
        LocationType: '',
        googleMapPlacesId: '',
        GoogleMapPlacesId: '',
      },
      googleMapPlaceID: '',
      searchRadius: 500,
      seekingTypes: 0,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
      isDoFilter: false,
      withPhoto: false,
      arrMeetingType: [],
      canHost: false,
    },
    defaultFilter: {
      isCanHost: false,
      ageMin: 18,
      ageMax: 99,
      location: {
        StateName: '',
        LocationType: '',
        googleMapPlacesId: '',
      },
      googleMapPlaceID: '',
      searchRadius: 500,
      seekingTypes: 0,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
      isDoFilter: false,
      withPhoto: false,
      arrMeetingType: [],
      canHost: false,
    },
    addDateFilter: {
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 500,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
      isDoFilter: false,
    },
    countSummary: {
      totalDates: 0,
      totalDateMatchingCount: 0,
    },
    positionScroll: 0,
  }),
  travelPlanState: Immutable({
    desOldScroll: 0,
    dataActiveNow: [],
    isLoadingActiveNow: false,
    dataTravelNearYou: [],
    isLoadingTravelNearYou: false,
    dataTravelEvents: [],
    isLoadingTravelEvents: false,
    dataListMyTravel: [],
    isLoadingListMyTravel: false,
    isLoadedListMyTravel: false,
    isHasMoreListMyTravel: true,
    pageNumListMyTravel: 1,
    dataDetailTravel: {},
    isLoadingDetailTravel: false,
    userTravel: [],
    isLoadingDefaultPage: false,
    isLoadedDefaultPage: false,
    searchData: [],
    isHasMoreData: true,
    locationSuggest: [],
    isLoadingSearchData: false,
    isShowMyTravels: false,
    isShowAddEditModal: false,
    itemTravelPlanEditing: {},
    isGetUserSearchSetting: false,
    filter: {
      ageMin: 18,
      ageMax: 99,
      location: {},
      googleMapPlaceID: '',
      searchRadius: 500,
      seekingTypes: 0,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
      isDoFilter: false,
      page: 1,
    },
    defaultFilter: {
      ageMin: 18,
      ageMax: 99,
      location: {},
      googleMapPlaceID: '',
      searchRadius: 500,
      seekingTypes: 0,
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
      isDoFilter: false,
      page: 1,
    },
  }),
  forumState: Immutable({
    isLoadedFirstData: false,
    isShowRegionalForumLocationModal: false, // This only for desktop
    isLoadingForum: false,
    forumList: [],
    // forum summary
    forumSummaryList: [],
    isLoadingForumSummary: false,

    // Sub Forum
    isLoadingSubForumList: false,
    subForumList: [],
    // Sub Forum Topic
    // isLoadingSubForumTopic: false,
    // subForumTopic: [],
    // subForumTopicPage: 1,
    // isHasMoreDataSubForumTopic: true,
    // Topic
    // isLoadingForumTopic: false,
    // forumTopic: [],
    // forumTopicPage: 1,
    // isHasMoreDataTopic: true,
    // topic details
    isLoadingTopicDetailsComment: false,
    isLoadingTopicDetails: false,
    isFetchingSearchResultByTag: false,
    likeUser: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
    },
    forumTopic: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
      currentForumID: -1,
      lastMessageItem: {},
    },
    topicSearchByTags: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
      total: 0,
      totalPages: 0,
    },
    subForumTopic: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
      currentForumID: -1,
      lastMessageItem: {},
    },
    topicDetails: {
      id: 0,
      likeCount: 0,
      topic: {
        isLiked: false,
        datePosted: '',
        isClosed: false,
        message: '',
        keyWords: [],
        likeCount: 0,
        replyCount: 0,
        isFollowing: false,
        seoURL: '',
        id: 0,
        title: '',
        poster: {
          userId: 0,
          userName: '',
          ageTitle: '',
          mainPhoto: {
            fullUrl: '',
          },
        },
      },
      messages: [],
      paginationInfo: {
        page: 1,
        size: 10,
        totalItems: 0,
        totalPages: 0,
      },
      permission: {
        canReply: false,
      },
      pageCommentLoaded: [],
      currentPage: 0,
    },
    trendingTopic: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
    },
    newestTopic: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
    },
    followingTopic: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
      isLoadedFirstData: false,
      total: 0,
      totalPages: 0,
    },
    myTopic: {
      data: [],
      page: 1,
      isLoading: false,
      isHasMoreData: true,
      isLoadedFirstData: false,
      total: 0,
      totalPages: 0,
    },
    searchId: 0,
    searchText: '',
    //
  }),
  communityState: Immutable({
    scrollOld: 0,
    article: {
      categoriesData: [],
      category: 0,
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    questionAndAnswer: {
      categoriesData: [],
      category: 0,
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    stories: {
      categoriesData: [],
      category: 0,
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    storyIdSelected: null,
    myStories: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    otg: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    otgGallery: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    otgVideo: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    otgPhoto: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    testimonial: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    communityDetail: {
      isLoading: false,
      contentItem: undefined,
      isOwner: false,
    },
    communityDetailPhoto: {
      isLoading: false,
      typeName: '',
      contentItem: undefined,
    },
    communityPhotoComments: {
      comments: [],
      totalItems: 0,
      totalPage: 0,
      size: 12,
      page: 1,
      isLoading: false,
      isHasMore: true,
    },
    communityDetailsComments: {
      comments: [],
      totalItems: 0,
      totalPage: 0,
      totalPages: 0,
      size: 12,
      page: 1,
      isLoading: false,
      isHasMore: true,
    },
    communityPhotoLikeUser: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    communityLikeUser: {
      data: [],
      page: 1,
      isHasMore: true,
      isLoading: false,
    },
    dataCommentTmp: [],
  }),
  supportTicketReducer: Immutable({
    supportTicketNewCount: 0,
    listSupportTickets: [],
    isHasMore: false,
    page: 1,
    isLoadingListSupportTickets: false,
    isLoadedListSupportTickets: false,
    isLoadingDetailSupportTicket: false,
    selectedTicketDetail: {},
    categoryContact: [],
    isShowListSupportTicketModal: false,
    refDetailTicket: null,
  }),
  rhpStore: Immutable({
    storeItems: {
      data: [],
      isLoading: false,
    },
    storeItemSelected: null, // storeItemSelected is RhpStoreOrder model
    cart: {
      infoCart: null,
      isLoading: false,
      isShowCartView: false,
    },
    orderDetail: {
      isLoading: false,
      infoOrder: null,
      orderId: -1,
    },
    imageStore: {
      isLoading: false,
      data: {}, // {productId: [RhpStoreImage]}
    },
    yourDiamonds: 0,
    showCheckOut: false,
    typePayment: TYPE_PAYMENT.MONEY,
    useExistsCard: false,
    showStorePayment: false,
    showOrderDetails: false,
    successCheckOutValid: true,
    productCategory: [],
  }),
  recentlyValidatedReducer: Immutable({
    data: [],
    isLoading: false,
    isHasMoreDate: true,
    page: 1,
    filter: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
      isSearchFilter: false,
    },
    defaultFilter: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
      isSearchFilter: false,
    },
    positionGoto: 0,
  }),

  sharedMedia: Immutable({
    dataByXmppId: {},
    isLoading: true,
  }),
  consumable: Immutable({
    profileBoostProducts: [],
    conversationBoostProducts: [],
    genderTypeChangeProducts: [],
    likeProducts: [],
    favProducts: [],
    invitesCreditProducts: [],
  }),
  profilePhotos: Immutable({
    isLoading: true,
    dataByPhotoId: [],
  }),
  groupState: Immutable({
    clubIdAutoEdit: -1,
    suggestedGroups: [],
    scrollOld: 0,
    idTimeout: null,
    recommendedGroups: [],
    isLoadedRecommendedGroups: false,
    isLoadingRecommendedGroups: false,
    groupsCanShare: [],
    dataDesktopPopularSearch: [],
    dataPopularSearch: [],
    desktopPopularPagingInfo: {
      size: 0,
      page: 0,
      isHasMore: false,
      totalItems: 0,
    },
    popularPagingInfo: {
      size: 0,
      page: 0,
      isHasMore: false,
      totalItems: 0,
    },
    isLoadingDataDesktopPopularSearch: false,
    isLoadingDataPopularSearch: false,
    desktopSearchPaginationInfo: {
      page: 1,
      size: 25,
      isHasMore: true,
    },
    searchPaginationInfo: {
      page: 1,
      size: 25,
      isHasMore: true,
    },
    dataGroupDetail: {
      idTimeout: null,
      alerts: [],
      joinedUsers: [],
      friendsAndFav: [],
      pageJoinedUsers: 1,
      isLoadingJoinedUsers: false,
      isHasMoreJoinedUsers: false,
      totalJoinedUser: 0,
      notificationsCount: 0,
      userGrants: {},
    },
    isLoadedDataGroupDetail: false,
    isLoadingDataGroupDetail: false,

    isLoadingDataJoinedGroup: false,
    loadedDataJoinedGroup: false,
    dataJoinedGroup: [],
    isLoadingDataMyGroup: false,
    loadedDataMyGroup: false,
    dataMyGroup: [],
    isLoadingSearchGroup: false,
    isLoadingSearchTag: false,
    filtersGroupSearch: {
      location: {},
      searchRadius: 0,
      isHasChangeFilter: false,
    },
    showMeMemberType: new categoryModel({
      id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
    }),
    filters: {
      location: {},
      searchRadius: 0,
    },
    defaultFilter: {
      location: {},
      searchRadius: 0,
    },
    defaultMemberFilters: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
    },
    memberFilters: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      isHasChangeFilter: false,
    },
    defaultSuggestedMemberFilters: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      ageMax: 99,
      ageMin: 18,
      location: {},
      searchRadius: 100,
      isHasChangeFilter: false,
    },
    suggestedMemberFilters: {
      showMeMemberType: new categoryModel({
        id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
      }),
      ageMax: 99,
      ageMin: 18,
      location: {},
      searchRadius: 100,
      isHasChangeFilter: false,
    },
    isChangeFilter: false,
    isGetUserSearchSetting: false,
    // Group Event
    isLoadingClubEvt: true, // set default loading is true to show skeleton
    pageNumberClubEvt: 1,
    isHasMoreClubEvt: false,
    totalClubEvt: 0,
    clubEvt: [],
    clubPastEvt: [],
    isHasMoreClubPastEvt: false,
    isLoadingClubPastEvt: false,
    pageNumberClubPastEvt: 1,
    totalClubPastEvt: 0,
    // Group Review
    totalVoteComments: 0,
    isLoadingVoteComments: false,
    pageNumberVoteComments: 1,
    sizeNumberVoteComments: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    isHasMoreVoteComments: false,
    voteComments: [],
    joinedRequest: {
      data: [],
      paginationInfo: {
        page: 1,
      },
      totalRequests: 0,
    },
    // Group Media
    isLoadingGroupPhotos: false,
    photos: {
      data: [],
      paginationInfo: {
        page: 1,
        size: 0,
        totalItems: 0,
        isHasMore: false,
      },
    },
    isLoadingGroupVideos: false,
    videos: {
      data: [],
      paginationInfo: {
        page: 1,
        size: 0,
        totalItems: 0,
        isHasMore: false,
      },
    },
    isLoadingGroupAlbums: false,
    albums: {
      data: [],
      paginationInfo: {
        page: 1,
        size: 0,
        totalItems: 0,
        isHasMore: false,
      },
    },
    isLoadingGroupActivity: false,
    activity: {
      data: [],
      paginationInfo: {
        page: 1,
        size: 0,
        totalItems: 0,
        isHasMore: false,
      },
    },
    postDetail: {
      comments: [],
      isLoadingComments: false,
      paginationInfoComments: { page: 1, isHasMore: true },
      likeUsers: [],
      isLoadingLikeUsers: false,
      paginationInfoUsers: { page: 1, isHasMore: true },
      likeCount: 0,
      replyCount: 0,
      isMemberLike: false,
      typeId: '',
      dateCreated: '',
      hasHeader: false,
      icon: '',
      typeName: '',
      entityText: '',
      actor: {},
      contentItem: {},
    },
    albumDetail: {
      likeCount: 0,
      replyCount: 0,
      isMemberLike: false,
      comments: [],
      isLoadingComments: false,
      paginationInfoComments: { page: 1, size: 24, isHasMore: true, totalItems: 0 },
      approvalState: '',
      clubAlbumID: -1,
      communityAction: {
        commentCount: 0,
        isLiked: false,
        likeCount: 0,
      },
      dateCreated: '',
      dateEdited: '',
      mediaCount: 0,
      title: '',
      poster: null,
      isInteractable: null,
    },
    mediaUploading: {
      pendingUploadingCount: 0,
      pendingUploadingPhotoIds: [],
      pendingUploadingVideoIds: [],
      pendingUploadingMediaIds: [],
      isHaveVideoUploading: false,
      isHavePhotoUploading: false,
      isHaveMediaUploading: false,
    },
    // Group user join
    groupJoins: {
      data: [],
      isLoading: false,
      isHasMore: true,
      pageNumber: 1,
      size: 0,
      total: 0,
      loadedData: false,
    },
    // Group Notification
    // Group Activity
    dataGroupActivities: [],
    isLoadingGroupActivities: false,
    isHasMoreGroupActivities: true,
    pageNumberGroupActivities: 1,
    totalGroupActivities: 0,
    // Group Join Request
    dataGroupJoinRequest: [],
    isLoadingGroupJoinRequest: false,
    isHasMoreGroupJoinRequest: true,
    pageNumberGroupJoinRequest: 1,
    totalGroupJoinRequest: 0,
    // Group Alerts
    dataGroupAlerts: [],
    isLoadingGroupAlerts: false,
    isHasMoreGroupAlerts: true,
    pageNumberGroupAlerts: 1,
    totalGroupAlerts: 0,
    // Suggested Users
    suggestedUsers: {
      data: [],
      isLoading: false,
      isLoadingMore: false,
      isHasMore: true,
      pageNumber: 1,
      total: 0,
      searchGuid: '',
    },
    suggestedUsersFilter: {
      memberTypes: [],
      defaultMemberTypes: [],
      minAge: 18,
      maxAge: 99,
      location: {},
      searchRadius: 100,
      isHasChangeFilter: false,
      isApplyFilter: false,
    },
    chats: {
      data: [],
    },
    groupRecentActivity: {
      data: [],
      isLoading: false,
      isHasMore: true,
      pageNumber: 0,
      total: 0,
      loadedData: false,
    },
    invitesReceived: {
      data: [],
      isLoading: false,
      page: 0,
      isHasMore: true,
      total: 0,
      loadedData: false,
    },
  }),
  inviteCreditState: Immutable({
    remainingLimit: 0,
    dailyLimit: 0,
    remainingCredits: 0,
  }),
  reportState: Immutable({
    mediaReportUploading: {
      pendingUploadingCount: 0,
      pendingUploadingPhotoIds: [],
      pendingUploadingVideoIds: [],
      pendingUploadingMediaIds: [],
      isHaveVideoUploading: false,
      isHavePhotoUploading: false,
      isHaveMediaUploading: false,
    },
  }),
};
